import React, { useState, useEffect } from 'react';
import { authAPI } from '../services/api';
import { log, error } from '../utils/logger';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
} from '@mui/material';

const TestPage = () => {
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testAPI = async () => {
    setLoading(true);
    try {
      log('API isteği gönderiliyor...');
      const response = await authAPI.verify();
      log('API yanıtı:', response);
      setResult(JSON.stringify(response.data, null, 2));
    } catch (err) {
      error('API hatası:', err);
      setResult(`Hata: ${err}`);
    } finally {
      setLoading(false);
    }
  };

  const testLogin = async () => {
    setLoading(true);
    try {
      log('Login isteği gönderiliyor...');
      const response = await authAPI.login('admin', 'admin123');
      log('Login yanıtı:', response);
      setResult(JSON.stringify(response.data, null, 2));
    } catch (err) {
      error('Login hatası:', err);
      setResult(`Hata: ${err}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          API Test Sayfası
        </Typography>
        <Typography variant="body1" paragraph>
          Bu sayfa backend bağlantısını test etmek için kullanılır.
        </Typography>
        
        <Box sx={{ mt: 2, mb: 2 }}>
          <Button 
            variant="contained" 
            onClick={testAPI}
            disabled={loading}
            sx={{ mr: 2 }}
          >
            API Test Et
          </Button>
          <Button 
            variant="contained" 
            onClick={testLogin}
            disabled={loading}
            color="secondary"
          >
            Login Test Et
          </Button>
        </Box>
        
        {loading && (
          <Typography variant="body2" sx={{ mt: 2 }}>
            İşlem yapılıyor...
          </Typography>
        )}
        
        {result && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="h6">Sonuç:</Typography>
            <Card sx={{ mt: 1 }}>
              <CardContent>
                <Typography component="pre" sx={{ wordBreak: 'break-all' }}>
                  {result}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default TestPage;
